export const fullScreen = {
    data () {
        return {
            isFullScreen: false
        }
    },
    mounted () {
        window.onresize = () => {
            this.isFullScreen = document.documentElement.offsetHeight >= window.screen.height
        }
    },
    beforeDestroy () {
        window.onresize = null
    },
    methods: {
        launchFullscreen() {
            this.isFullScreen = true
            if (document.documentElement.offsetHeight >= window.screen.height) return;
            let element = document.documentElement;
            if(element.requestFullscreen) {
                element.requestFullscreen();
            } else if(element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if(element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if(element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
        },
        exitFullscreen() {
            this.isFullScreen = false
            if (document.documentElement.offsetHeight < window.screen.height) {
                return;
            }
            if(document.exitFullscreen) {
                document.exitFullscreen();
            } else if(document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if(document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        }
    }
};
